// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { TerceraComboBox } from './TerceraComboBox';
import { LineStyleUtils } from '@shared/commons/UtilsClasses/LineStyleUtils';
export class TerceraLineStyleComboBox extends TerceraComboBox {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.TerceraLineStyleComboBox;
    }
    oninit() {
        super.oninit();
        if (this.get('items').length) {
            if (this.get('useStyleProperties')) {
                this.menuItems = this.updateMenuItems(this.get('selectedItem'));
            }
            return;
        }
        const styleItems = LineStyleUtils.getCBItems();
        void this.set({ items: styleItems });
    }
    onSelectedItemChanged(newValue, oldValue) {
        super.onSelectedItemChanged(newValue, oldValue);
        if (isNullOrUndefined(newValue)) {
            return;
        }
        const icon = newValue.svgImage;
        if (!isNullOrUndefined(icon)) {
            this.set({ icon });
        }
    }
}
TerceraComboBox.extendWith(TerceraLineStyleComboBox, {
    data: () => {
        return {
            showLastValue: true,
            useStyleProperties: false,
            useSVGView: true,
            updateComboBoxClass: 'upClassLineStyleComboBox'
        };
    }
});
